<template>
	<v-chart :options="chartOptions" autoresize />
</template>

<script>
import { defineComponent } from 'vue';
import ECharts from 'vue-echarts/components/ECharts';

// Import ECharts modules manually to reduce bundle size
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/grid';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/chart/bar';

export default {
	name: 'ScoreChart',
	components: {
		'v-chart': ECharts
	},
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	computed: {
		chartOptions() {
			const labels = this.data.map(item => `HK${item.semester}/Năm ${item.school_year}`);
			return {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					},
					backgroundColor: '#f5f5f5',
					borderColor: '#ddd',
					borderWidth: 1,
					padding: [10, 15],
					textStyle: {
						color: '#333',
						fontSize: 14
					}
				},
				legend: {
					data: ['Điểm học tập', 'Điểm rèn luyện', 'Điểm rèn luyện KTX'],
					top: '2.5%',
					textStyle: {
						fontSize: 16,
						color: '#333'
					},
					itemWidth: 20,
					itemHeight: 10
				},
				grid: {
					left: '5%',
					right: '5%',
					bottom: '15%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					data: labels,
					axisLine: {
						lineStyle: {
							color: '#333',
							width: 1
						}
					},
					axisLabel: {
						color: '#333',
						fontSize: 12,
						formatter: value => `${value}`
					}
				},
				yAxis: {
					type: 'value',
					axisLine: {
						lineStyle: {
							color: '#333',
							width: 1
						}
					},
					axisLabel: {
						color: '#333',
						fontSize: 12
					},
					splitLine: {
						lineStyle: {
							color: '#ddd',
							width: 1
						}
					}
				},
				series: [
					{
						name: 'Điểm học tập',
						type: 'line',
						data: this.data.map(item => item.course_point),
						lineStyle: {
							color: '#ff5722',
							width: 3,
							type: 'solid'
						},
						itemStyle: {
							color: '#ff7043'
						},
						smooth: true,
						symbol: 'circle',
						symbolSize: 8
					},
					{
						name: 'Điểm rèn luyện',
						type: 'line',
						data: this.data.map(item => item.school_training_point),
						lineStyle: {
							color: '#03a9f4',
							width: 3,
							type: 'solid'
						},
						itemStyle: {
							color: '#03a9f4'
						},
						smooth: true,
						symbol: 'triangle',
						symbolSize: 8
					},
					{
						name: 'Điểm rèn luyện KTX',
						type: 'line',
						data: this.data.map(item => item.dormitory_training_point),
						lineStyle: {
							color: '#4caf50',
							width: 3,
							type: 'solid'
						},
						itemStyle: {
							color: '#66bb6a'
						},
						smooth: true,
						symbol: 'rect',
						symbolSize: 8
					}
				],
				dataZoom: [
					{
						type: 'inside'
					},
					{
						type: 'slider',
						show: true,
						top: '90%',
						height: '5%',
						handleSize: '8px',
						handleStyle: {
							color: '#ff5722',
							borderColor: '#ff5722'
						}
					}
				],
				toolbox: {
					feature: {
						saveAsImage: {
							title: 'Lưu hình ảnh',
							iconStyle: {
								borderColor: '#2B59B2'
							}
						}
					},
					right: '5%'
				},
				backgroundColor: '#fafafa'
			};
		}
	}
};
</script>

<style scoped>
.v-chart {
	width: 100%;
	height: 600px;
}
</style>
